import { ButtonNavigation, Colors, Icon } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface CommentThreadNavigationProps {
    /** Zero-based index of the question shown. */
    index: number;
    total: number;
    onChange: (index: number) => void;
}

/** Moves between the commented questions, as the questionnaire moves between its questions. */
export const CommentThreadNavigation = ({
    index,
    total,
    onChange,
}: CommentThreadNavigationProps) => {
    const { t } = useAmelioTranslations();

    return (
        <nav
            aria-label={t('reviewAnswer.commentThread.questionPosition', {
                current: index + 1,
                total,
            })}
            className={'flex items-center justify-between gap-2'}
        >
            <ButtonNavigation
                direction={'previous'}
                size={'md'}
                wrap
                icon={
                    <Icon
                        name={'arrow-arrow-left-1'}
                        color={Colors.BASE}
                        size={'md'}
                        strokeWidth={3}
                    />
                }
                onClick={() => onChange(index - 1)}
                disabled={index === 0}
                ariaLabel={t('answer.ariaPreviousQuestion')}
                dataTestId={'comment-thread-previous'}
            >
                {t('answer.previousQuestion')}
            </ButtonNavigation>

            <ButtonNavigation
                direction={'next'}
                size={'md'}
                wrap
                icon={
                    <Icon
                        name={'arrow-arrow-right'}
                        color={Colors.BASE}
                        size={'md'}
                        strokeWidth={3}
                    />
                }
                onClick={() => onChange(index + 1)}
                disabled={index === total - 1}
                ariaLabel={t('answer.ariaNextQuestion')}
                dataTestId={'comment-thread-next'}
            >
                {t('answer.nextQuestion')}
            </ButtonNavigation>
        </nav>
    );
};
